import { render, staticRenderFns } from "./IconSvgHRLFABoardOfDirectors.vue?vue&type=template&id=42b35a53&scoped=true&"
import script from "./IconSvgHRLFABoardOfDirectors.vue?vue&type=script&lang=js&"
export * from "./IconSvgHRLFABoardOfDirectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b35a53",
  null
  
)

export default component.exports